<template>
  <div class='page-box'>
    退住详情
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
